import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {UserRoleModel} from '@/libs/Api';
import {UserRolesDataService} from '@/libs/user-roles/user-roles-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const userRolesStore = registerCrudStore<UserRoleModel, UserRoleModel>(BusinessModule.UserRole, new UserRolesDataService());
